import { token } from 'odyssey';
import styled from 'styled-components';

export const StyledLabel = styled.label`
  display: block;
  font-size: ${token('font-size-xs')};
  font-weight: ${token('font-weight-md')};
  margin-bottom: ${token('space-2')};
`;

export const Required = styled.span`
  display: inline-block;
  margin-left: ${token('space-1')};
  color: ${token('color-negative-semantic')};
`;
